var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "13px",
    viewBox: "0 0 22 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "62D6D1A7-2263-46DE-8C4E-0CEFCC3BDDA6@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.7058236,5.86162499 L6.21576516,10.3552425 C6.60699685,10.7450581 6.60814482,11.3782221 6.21832921,11.7694538 C5.82851361,12.1606855 5.19534967,12.1618334 4.80411798,11.7720178 L0.294176419,7.27840029 C-0.0970552752,6.88858468 -0.0982032419,6.25542074 0.291612364,5.86418905 C0.681427969,5.47295736 1.31459191,5.47180939 1.7058236,5.86162499 Z M19.3517105,0.292893219 C19.7422348,-0.0976310729 20.3753998,-0.0976310729 20.7659241,0.292893219 C21.1564484,0.683417511 21.1564484,1.31658249 20.7659241,1.70710678 L11.2170483,11.7707369 C10.8265241,12.1612612 10.1933591,12.1612612 9.80283479,11.7707369 L5.29058198,7.24486838 C4.90005769,6.85434409 4.90005769,6.22117911 5.29058198,5.83065482 C5.68110627,5.44013053 6.31427125,5.44013053 6.70479554,5.83065482 L10.5099416,9.64941661 Z M14.5333409,1.62858862 C14.9323657,2.01042318 14.9463012,2.64343478 14.5644666,3.04245962 L10.9819476,6.78829841 C10.600113,7.18732324 9.96710141,7.20125871 9.56807658,6.81942416 C9.16905174,6.4375896 9.15511627,5.804578 9.53695083,5.40555316 L13.1194699,1.65971437 C13.5013044,1.26068954 14.134316,1.24675407 14.5333409,1.62858862 Z",
    id: "svg-check"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03_Gestion_abonnements",
    transform: "translate(-285.000000, -554.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(269.000000, 517.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/align_center-Copy",
    transform: "translate(16.490058, 37.936370)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#svg-check"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#162A41",
    xlinkHref: "#svg-check"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecks);
export default __webpack_public_path__ + "static/media/checks.b5f92c2b8e8fe6a3bf6e20dba539c188.svg";
export { ForwardRef as ReactComponent };